.ugc-star-wrap {
  width: 100%;
  max-width: 304px;
  padding: 0;
  margin: 0 auto;
  
  .ugc-star-item {
    display: flex;
    align-items: center;
    list-style-type: none;
  }

  &.round-corner{
    gap:2px;
  }
}


.tips-wrap {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 304px;
  padding-top: 4px;
  margin: 0 auto;

  .tip {
    line-height: 24px;
    font-size: 14px;
    color: #999;
  }
}
